<template>
  <div>
    <v-card class=" pt-10">
      <v-card-text>
        <center class=" mb-5">
          <section v-if="displayProcess">
            <h1>{{ processMessage }}</h1>
          </section>
          <section v-else-if="displayQrcode">
            <vue-qrcode
              :value="qrcodeString"
              :options="{ width: 200,
                          color: { dark: '#CF5925ff', light: '#ffffffff' }
              }"
            ></vue-qrcode>
            <!-- {{ qrcodeString }} -->
          </section>
          <div class="card-content">
            <h4 class="ml-3">
              {{ formatDate(booking.courseDate) }}
            </h4>
            <v-list-item>
              <v-list-item-avatar
                size="large"
                rounded
                color="#a8a8a8"
              >
                <v-list-item-content class="time-span">
                  <div>{{ formatTime(booking.courseStartTime) }}</div>
                  <div>~</div>
                  <div>{{ formatTime(booking.courseEndTime) }}</div>
                </v-list-item-content>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-content> Course: {{ `${booking.course.courseCode} ${booking.course.courseName}` }} </v-list-item-content>
                <v-list-item-content> Student: {{ booking.userRecord.fullName }} </v-list-item-content>
                <v-list-item-content> Center: {{ booking.center.description }} </v-list-item-content>
              </v-list-item-content>
            </v-list-item>
          </div>
        </center>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { ref, onMounted, nextTick, onUnmounted, toRefs, watch } from 'vue'
import { formatTime, formatDate } from '@/utils/helper'

const displayQrcode = ref(true)
const displayProcess = ref(false)
const processMessage = ref('Assigning Locker Key Please Wait...')

const props = defineProps({
  booking: {
    id: -1,
    userRecord: {
      fullName: 'Jason LI',
    },
    course: {
      courseCode: 'TST',
      courseName: 'EM',
    },
    center: {
      description: 'TST',
    },
    courseDate: '2023-02-24',
    courseStartTime: '2023-02-24 09:00',
    courseEndTime: '2023-02-24 10:00',
  },
})

const { booking } = toRefs(props)

// const booking = ref({
//   id: -1,
//   userRecord: {
//     fullName: 'Jason LI',
//   },
//   course: {
//     courseCode: 'TST',
//     courseName: 'EM',
//   },
//   courseDate: '2023-02-24',
//   courseStartTime: '2023-02-24 09:00',
//   courseEndTime: '2023-02-24 10:00',
// })

const qrcodeString = ref('-1')
function getQrcodeString() {
  const obj = {
    id: booking.value.id,
    timestamp: new Date().valueOf(),
    type: 'course',
  }
  const objString = JSON.stringify(obj)

  return objString
}
let interval = null
onMounted(() => {
  qrcodeString.value = getQrcodeString()

  // refresh the qrcode every 60 seconds
  interval = setInterval(() => {
    nextTick(() => {
      if (displayQrcode.value) {
        qrcodeString.value = getQrcodeString()
      }
      console.log('trigger interval')
    })
  }, 30000)
})
onUnmounted(() => {
  console.log('onUnmounted', interval)
  clearInterval(interval)
})

watch(booking, (newVal, oldVal) => {
  console.log('watch booking', newVal, oldVal)
  if (newVal.id !== oldVal.id) {
    qrcodeString.value = getQrcodeString()
  }
})

</script>
<style scoped>
.time-span {
  color: white
}

</style>
